import { usePaginatedPosts } from './usePaginatedPosts';

export interface UseMainPostId {
    tokenName: string;
    flairId?: string;
}

export const useMainPostId = (payload: UseMainPostId) => {
    const { tokenName, flairId } = payload;
    const { postIds } = usePaginatedPosts({ type: 'partner', tokenName, flairId, fetchLimit: 12 });
    const { postIds: pinnedPostsIds } = usePaginatedPosts({ type: 'pinnedPartner', tokenName, flairId });

    const combinedPosts = Array.from(new Set([...pinnedPostsIds, ...postIds]));
    return combinedPosts[0];
};
